// src/views/public/VerifierRecu.jsx
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { verifierRecu } from "../../services/publicCaisseService";

const BLEU = "#0a4d8c";
const BLEU_FONCE = "#063764";
const VERT = "#1a7a4c";
const ROUGE = "#c0392b";

// ── Icônes SVG inline (pas de dépendance à une police externe) ──
const IconShieldCheck = (props) => (
  <svg viewBox="0 0 24 24" width={props.size || 18} height={props.size || 18} fill="none" stroke={props.color || "#fff"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 3l8 4v5c0 5-3.5 8.5-8 9-4.5-.5-8-4-8-9V7l8-4z" />
    <path d="M9 12l2 2 4-4" />
  </svg>
);
const IconCheck = (props) => (
  <svg viewBox="0 0 24 24" width={props.size || 30} height={props.size || 30} fill="none" stroke={props.color || VERT} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M5 12l5 5L19 7" />
  </svg>
);
const IconX = (props) => (
  <svg viewBox="0 0 24 24" width={props.size || 30} height={props.size || 30} fill="none" stroke={props.color || ROUGE} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M18 6L6 18M6 6l12 12" />
  </svg>
);
const IconAlertTriangle = (props) => (
  <svg viewBox="0 0 24 24" width={props.size || 15} height={props.size || 15} fill="none" stroke={props.color || "#8a6414"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M10.24 3.5a2 2 0 013.52 0l8.2 14.5A2 2 0 0120.2 21H3.8a2 2 0 01-1.76-3l8.2-14.5z" />
    <path d="M12 9v4M12 17h.01" />
  </svg>
);
const IconBuilding = (props) => (
  <svg viewBox="0 0 24 24" width={props.size || 12} height={props.size || 12} fill="none" stroke={props.color || "#4a5568"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="4" y="3" width="16" height="18" rx="1" />
    <path d="M9 8h.01M15 8h.01M9 12h.01M15 12h.01M9 16h.01M15 16h.01" />
  </svg>
);
const IconReceipt = (props) => (
  <svg viewBox="0 0 24 24" width={props.size || 14} height={props.size || 14} fill="none" stroke={props.color || "#9aa5b1"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M5 3l1.5 1.5L8 3l1.5 1.5L11 3l1.5 1.5L14 3l1.5 1.5L17 3l1.5 1.5L20 3v18l-1.5-1.5L17 21l-1.5-1.5L14 21l-1.5-1.5L11 21l-1.5-1.5L8 21l-1.5-1.5L5 21z" />
    <path d="M8 9h8M8 13h8" />
  </svg>
);
const IconUser = (props) => (
  <svg viewBox="0 0 24 24" width={props.size || 14} height={props.size || 14} fill="none" stroke={props.color || "#9aa5b1"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="8" r="4" />
    <path d="M4 21c0-4 4-6 8-6s8 2 8 6" />
  </svg>
);
const IconCash = (props) => (
  <svg viewBox="0 0 24 24" width={props.size || 14} height={props.size || 14} fill="none" stroke={props.color || "#9aa5b1"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="6" width="20" height="12" rx="2" />
    <circle cx="12" cy="12" r="2.5" />
  </svg>
);
const IconCalendar = (props) => (
  <svg viewBox="0 0 24 24" width={props.size || 14} height={props.size || 14} fill="none" stroke={props.color || "#9aa5b1"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="5" width="18" height="16" rx="2" />
    <path d="M3 10h18M8 3v4M16 3v4" />
  </svg>
);
const IconLock = (props) => (
  <svg viewBox="0 0 24 24" width={props.size || 12} height={props.size || 12} fill="none" stroke={props.color || "#9aa5b1"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="5" y="11" width="14" height="9" rx="2" />
    <path d="M8 11V7a4 4 0 018 0v4" />
  </svg>
);
const IconQrcode = (props) => (
  <svg viewBox="0 0 24 24" width={props.size || 13} height={props.size || 13} fill="none" stroke={props.color || "#fff"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="3" width="7" height="7" rx="1" />
    <rect x="14" y="3" width="7" height="7" rx="1" />
    <rect x="3" y="14" width="7" height="7" rx="1" />
    <path d="M14 14h3v3h-3zM19 14h2M14 19h2M19 19h2" />
  </svg>
);

export default function VerifierRecu() {
  const { slug, uuid } = useParams();
  const [etat, setEtat] = useState("chargement"); // 'chargement' | 'valide' | 'introuvable'
  const [data, setData] = useState(null);

  useEffect(() => {
    let annule = false;
    verifierRecu(slug, uuid)
      .then((res) => {
        if (annule) return;
        setData(res);
        setEtat("valide");
      })
      .catch(() => {
        if (!annule) setEtat("introuvable");
      });
    return () => { annule = true; };
  }, [slug, uuid]);

  return (
    <div style={styles.page}>
      <style>{`
        @keyframes spin { to { transform: rotate(360deg); } }
        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(10px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes popIn {
          0% { opacity: 0; transform: scale(0.6); }
          60% { transform: scale(1.06); }
          100% { opacity: 1; transform: scale(1); }
        }
        .vr-fade { animation: fadeInUp 0.45s ease both; }
        .vr-pop { animation: popIn 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) both; }
      `}</style>

      <div style={styles.wrap}>
        <div style={styles.card}>
          <div style={styles.brandBar}>
            <div style={styles.brandIcon}>
              <IconShieldCheck size={18} color="#fff" />
            </div>
            <div>
              <div style={styles.brandTxt}>Vérification de reçu</div>
              <div style={styles.brandSub}>Suivi Scolaire — Portail officiel</div>
            </div>
          </div>

          <div style={styles.body}>
            {etat === "chargement" && <Chargement />}
            {etat === "introuvable" && <Introuvable />}
            {etat === "valide" && data && <Valide data={data} />}
          </div>

          <div style={styles.footer}>
            <IconLock size={12} color="#9aa5b1" />
            <span style={{ marginLeft: 5 }}>
              Cette page confirme uniquement l'authenticité du reçu scanné.
              Pour toute question, contactez directement l'établissement.
            </span>
          </div>
        </div>

        <div style={styles.hint}>
          <IconQrcode size={13} color="#fff" />
          <span style={{ marginLeft: 5 }}>Vérifié via le QR code imprimé sur le reçu papier</span>
        </div>
      </div>
    </div>
  );
}

function Chargement() {
  return (
    <div style={styles.centerBlock}>
      <div style={styles.spinner} />
      <div style={styles.chargementTxt}>Vérification en cours…</div>
      <div style={styles.chargementSousTxt}>Consultation du registre de l'établissement</div>
    </div>
  );
}

function Introuvable() {
  return (
    <div className="vr-fade" style={styles.centerBlock}>
      <div className="vr-pop" style={{ ...styles.badge, background: "#fdeceb" }}>
        <IconX size={30} color={ROUGE} />
      </div>
      <div style={{ ...styles.titre, color: ROUGE }}>Reçu introuvable</div>
      <div style={styles.sousTitre}>
        Ce lien ne correspond à aucun reçu connu. Le QR code est peut-être
        endommagé, ou le reçu provient d'un autre établissement.
      </div>
    </div>
  );
}

function Valide({ data }) {
  const estAnnule = data.statut === "ANNULE";
  const couleur = estAnnule ? ROUGE : VERT;
  const fond = estAnnule ? "#fdeceb" : "#e7f6ee";

  return (
    <div className="vr-fade" style={styles.centerBlock}>
      <div className="vr-pop" style={{ ...styles.badge, background: fond }}>
        {estAnnule ? <IconAlertTriangle size={28} color={couleur} /> : <IconCheck size={30} color={couleur} />}
      </div>

      <div style={{ ...styles.titre, color: couleur }}>
        {estAnnule ? "Reçu annulé" : "Reçu authentique"}
      </div>
      <div style={styles.pillEtablissement}>
        <IconBuilding size={12} />
        <span style={{ marginLeft: 5 }}>{data.etablissement}</span>
      </div>

      <div style={styles.details}>
        <Ligne icone={<IconReceipt />} label="N° de reçu" valeur={data.numero_recu} accent />
        <div style={styles.separateur} />
        <Ligne icone={<IconUser />} label="Élève" valeur={data.eleve} />
        <div style={styles.separateur} />
        <Ligne
          icone={<IconCash />}
          label="Montant"
          valeur={`${Number(data.montant).toLocaleString()} FCFA`}
          accent
        />
        <div style={styles.separateur} />
        <Ligne
          icone={<IconCalendar />}
          label="Date"
          valeur={new Date(data.date_versement).toLocaleDateString("fr-FR", {
            day: "2-digit", month: "long", year: "numeric",
          })}
        />
      </div>

      {estAnnule ? (
        <div style={styles.avertissement}>
          <IconAlertTriangle size={15} />
          <span style={{ marginLeft: 7 }}>
            Ce versement a été annulé par l'établissement après émission du reçu.
            Ce document ne doit pas être considéré comme preuve de paiement.
          </span>
        </div>
      ) : (
        <div style={styles.confirmation}>
          <IconCheck size={14} color={VERT} />
          <span style={{ marginLeft: 6 }}>Ce document a été émis officiellement par l'établissement</span>
        </div>
      )}
    </div>
  );
}

function Ligne({ icone, label, valeur, accent }) {
  return (
    <div style={styles.ligne}>
      <span style={styles.ligneLabel}>
        <span style={{ marginRight: 7, display: "inline-flex" }}>{icone}</span>
        {label}
      </span>
      <span style={{ ...styles.ligneValeur, ...(accent ? styles.ligneValeurAccent : {}) }}>
        {valeur}
      </span>
    </div>
  );
}

const styles = {
  page: {
    minHeight: "100vh",
    background: `linear-gradient(155deg, ${BLEU_FONCE} 0%, #0d5c9e 38%, #f0f4f9 38%)`,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 20,
    fontFamily: "'Inter', system-ui, -apple-system, 'Segoe UI', sans-serif",
  },
  wrap: { width: "100%", maxWidth: 420 },
  card: {
    background: "#fff",
    borderRadius: 18,
    boxShadow: "0 20px 50px -12px rgba(6,55,100,0.35), 0 4px 14px rgba(6,55,100,0.10)",
    overflow: "hidden",
  },
  brandBar: {
    display: "flex", alignItems: "center", gap: 11,
    padding: "18px 22px",
    background: `linear-gradient(135deg, ${BLEU} 0%, ${BLEU_FONCE} 100%)`,
  },
  brandIcon: {
    width: 34, height: 34, borderRadius: 10,
    background: "rgba(255,255,255,0.15)",
    display: "flex", alignItems: "center", justifyContent: "center",
    flexShrink: 0,
  },
  brandTxt: { fontSize: 14.5, fontWeight: 700, color: "#fff", letterSpacing: 0.1 },
  brandSub: { fontSize: 11.5, color: "rgba(255,255,255,0.75)", marginTop: 1 },
  body: { padding: "26px 24px 20px" },
  footer: {
    padding: "13px 22px",
    background: "#f7fafd",
    borderTop: "1px solid #eef1f5",
    fontSize: 10.8, color: "#9aa5b1", textAlign: "center", lineHeight: 1.5,
    display: "flex", alignItems: "flex-start", justifyContent: "center",
  },
  hint: {
    display: "flex", alignItems: "center", justifyContent: "center",
    marginTop: 16,
    fontSize: 11.5, fontWeight: 500,
    color: "#fff",
    background: "rgba(6,55,100,0.55)",
    padding: "7px 14px",
    borderRadius: 20,
    width: "fit-content",
    margin: "16px auto 0",
    backdropFilter: "blur(2px)",
  },
  centerBlock: { textAlign: "center" },
  spinner: {
    width: 38, height: 38, margin: "6px auto 0",
    border: "3px solid #e3ecf7", borderTopColor: BLEU,
    borderRadius: "50%", animation: "spin 0.75s linear infinite",
  },
  chargementTxt: { color: "#333", marginTop: 16, fontSize: 14.5, fontWeight: 600 },
  chargementSousTxt: { color: "#9aa5b1", marginTop: 4, fontSize: 12.5 },
  badge: {
    width: 66, height: 66, borderRadius: "50%",
    display: "flex", alignItems: "center", justifyContent: "center",
    margin: "0 auto 16px",
  },
  titre: { fontSize: 20, fontWeight: 800, letterSpacing: -0.2 },
  pillEtablissement: {
    display: "inline-flex", alignItems: "center",
    marginTop: 9, marginBottom: 20,
    background: "#f0f4f9", color: "#4a5568",
    padding: "5px 12px", borderRadius: 20,
    fontSize: 12, fontWeight: 600,
  },
  details: {
    background: "#f7fafd", border: "1px solid #eef1f5",
    borderRadius: 12, padding: "5px 16px", textAlign: "left",
  },
  separateur: { height: 1, background: "#eef1f5" },
  ligne: {
    display: "flex", alignItems: "center", justifyContent: "space-between",
    padding: "11px 0",
  },
  ligneLabel: { color: "#7a8492", fontSize: 12.8, display: "flex", alignItems: "center" },
  ligneValeur: { fontWeight: 600, color: "#1a1a1a", fontSize: 13.5, textAlign: "right" },
  ligneValeurAccent: { color: BLEU_FONCE, fontWeight: 700 },
  avertissement: {
    marginTop: 16, display: "flex",
    background: "#fff6e6", color: "#8a6414",
    border: "1px solid #f5e3b8", borderRadius: 10, padding: "11px 13px",
    fontSize: 12, textAlign: "left", lineHeight: 1.55,
  },
  confirmation: {
    marginTop: 16, color: VERT, fontSize: 12, fontWeight: 600,
    display: "flex", alignItems: "center", justifyContent: "center",
  },
};